if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

  
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });


    $('.top-content__slider').slick({
        arrows: false, 
        autoplay: true, 
        autoplaySpeed: 5000,
        dots: false, 
        fade: false,
        pauseOnHover: false,
        speed: 700
    });

	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault()
		$('html, body').animate(
			{
				scrollTop: $($(this).attr('href')).offset().top-150,
			},
		500,
		'linear'
	)
	})

	$('#menu-btn').on("click", function(e) {
		$('html').addClass('hide-overflow');
		$('.navigation').addClass('open');
		$('.navigation').stop().animate({left:'0px'},{duration:300});
		if($('.navigation ul li a').hasClass('.item-open')){
			$(".item-open").get(0).scrollIntoView(false);
		}
	});

	$('.close-menu').on("click", function(e) {
		e.preventDefault();
		$('html').removeClass('hide-overflow');
		$('.navigation').removeClass('open');
		$('.navigation').stop().animate({left:'100%'},{queue:false,duration:300});
	});

	$('.form-module-wrapper').append("<div class='hide-object fade-in lines container'></div>");

	const animateHTML = function () {
        let elems,
            elemsShow,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            elemsShow = document.getElementsByClassName('show-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        }; 
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            } 
            for (let i = 0; i < elemsShow.length; i++) {
                let posFromTop = elemsShow[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight >= 0) {
                    elemsShow[i].className = elemsShow[i].className.replace('show-object', 'hide-object')
                } 
            } 
        };
        return {
            init: init 
        }
    };
    animateHTML().init();
	

})();

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function titleCase(str) {
	var splitStr = str.toLowerCase().split(' ');
	for (var i = 0; i < splitStr.length; i++) {
		// You do not need to check if i is larger than splitStr length, as your for does that for you
		// Assign it back to the array
		splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
	}
	// Directly return the joined string
	return splitStr.join(' '); 
 }